import React from "react"
import autobind from "class-autobind"
import { Toggle, Paper, TextField } from "material-ui"
import strings from "../../../localization/strings"
import AccountStore from "../../../stores/AccountStore"
import { checkJobFieldAvailable } from "../../../helpers/jobHelper"
interface IProps {
    allowPunch: boolean
    messageForDisablePunches: string
    allowJob: boolean
    disableExpense: boolean
    handleChange(allowPunch: boolean, messageForDisablePunches: string, allowJob: boolean, disableExpense: boolean): void
}
interface IState {
    expand: boolean
    allowPunch: boolean
    messageForDisablePunches: string
    allowJob: boolean
    disableExpense: boolean
}

export default class AccountHierarchyDefinitionForAccount extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            expand: false,
            allowPunch: props.allowPunch,
            messageForDisablePunches: props.messageForDisablePunches,
            allowJob: props.allowJob,
            disableExpense: props.disableExpense
        }
        autobind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            allowPunch: nextProps.allowPunch,
            messageForDisablePunches: nextProps.messageForDisablePunches,
            allowJob: nextProps.allowJob,
            disableExpense: nextProps.disableExpense
        })
    }

    handleSave() {
        !this.state.allowPunch && this.state.messageForDisablePunches.trim().length &&
            this.props.handleChange(this.state.allowPunch, this.state.messageForDisablePunches, this.state.allowJob, this.state.disableExpense)
        this.state.allowPunch &&
            this.props.handleChange(this.state.allowPunch, null, this.state.allowJob, this.state.disableExpense)
    }

    render() {
        const messageForDisablePunches =
            !this.state.allowPunch ?
                this.state.messageForDisablePunches !== null ?
                    this.state.messageForDisablePunches :
                    strings.Punches_are_not_allowed_at_Account_level :
                null
        return (
            <Paper style={{ marginBottom: 40, minHeight: 100, position: "relative" }}>
                <i
                    style={{ position: "absolute", right: 10, top: 10, fontSize: 18 }}
                    className={!this.state.expand ? "fa fa-chevron-down itemActionButton" : "fa fa-chevron-up itemActionButton"}
                    onClick={() => this.setState({ expand: !this.state.expand })}
                />
                <div style={{ fontSize: "20px", fontWeight: "bold", marginLeft: "30px", paddingTop: "20px" }}>
                    {strings.Account}
                </div>
                <div style={{ fontSize: "15px", marginLeft: "30px", marginTop: "8px" }}>
                    {strings.Level} 0
                </div>
                {this.state.expand &&
                    <div style={{ paddingTop: 20, paddingBottom: 15 }}>
                        {AccountStore.getJobsEnabled() &&
                            <Toggle
                                label={checkJobFieldAvailable('singular') ? `Allow ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Allow_Job}
                                toggled={this.state.allowJob}
                                onToggle={(_, allowJob) => this.setState({ allowJob }, () => this.handleSave())}
                                style={{ maxWidth: 250, marginLeft: 30, marginBottom: 20 }}
                                labelStyle={{ fontSize: 15 }}
                            />
                        }
                        {AccountStore.getExpensesEnabled() &&
                            <Toggle
                                label={strings.Disable_Expense}
                                toggled={this.state.disableExpense}
                                onToggle={(_, disableExpense) => this.setState({ disableExpense }, () => this.handleSave())}
                                style={{ maxWidth: 250, marginLeft: 30, marginBottom: 20 }}
                                labelStyle={{ fontSize: 15 }}
                            />
                        }
                        <div style={{ display: "flex" }}>
                            <Toggle
                                label={strings.Allow_Punches}
                                toggled={this.state.allowPunch}
                                onToggle={(_, allowPunch) =>
                                    this.setState({
                                        allowPunch,
                                        messageForDisablePunches: !allowPunch ? strings.Punches_are_not_allowed_at_Account_level : null
                                    }, () =>
                                        this.handleSave()
                                    )
                                }
                                style={{ maxWidth: 250, marginLeft: 30 }}
                                labelStyle={{ fontSize: 15 }}
                            />
                            {!this.state.allowPunch &&
                                <TextField
                                    floatingLabelText={strings.Disable_Message}
                                    style={{ marginTop: -28, marginLeft: 30, marginRight: 30, width: 600 }}
                                    value={messageForDisablePunches}
                                    onChange={(_, value) => this.setState({ messageForDisablePunches: value })}
                                    onFocus={e => e.target.selectionStart = this.state.messageForDisablePunches.length}
                                    onBlur={() => this.state.messageForDisablePunches.length && this.handleSave()}
                                    errorText={!messageForDisablePunches.length && strings.This_field_is_required}
                                />
                            }
                        </div>
                    </div>
                }
            </Paper>
        )
    }
}
